<template>
  <v-sheet>
    <div class="month-row-wrap">
      <!-- <v-row>
        <v-col cols="4" v-for="item in planData" :key="item.month">
          <div class="d-flex justify-center align-center">
            <span style="font-size: 1rem; font-weight: 500; width:30%;">{{ item.month.replace(/^0/, '') }}월:</span>
            <div style="width:70%;">
              <v-text-field v-model="item.workCnt" outlined dense class="text-right" readonly />
            </div>
          </div>
        </v-col>
      </v-row> -->
      <v-row v-for="(row, rowIndex) in monthRows" :key="rowIndex" class="month-row">
        <v-col v-for="item in row" :key="item.month" cols="4" class="pa-0 d-flex align-center">
          <div class="d-flex align-center">
            <span>{{ item.month.replace(/^0/, '') }}월</span>
            <div>
              <v-text-field v-model="item.workCnt" outlined dense class="text-right" readonly />
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'SafetyWorkPlanMonthCard',
  props: {
    planData: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    monthRows() {
      const mlist = this.planData || []
      // 4행 3열 배열로 변환 (각 행에 3개씩)
      return [
        mlist.slice(0, 3), // 1-3월
        mlist.slice(3, 6), // 4-6월
        mlist.slice(6, 9), // 7-9월
        mlist.slice(9, 12) // 10-12월
      ]
    }
  }
}
</script>

<style scoped>
.month-row-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.month-row {
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}
.month-value {
  font-weight: bold;
}
.text-right ::v-deep input {
  text-align: right;
}
.text-right ::v-deep .v-input__control {
  min-width: 0;
}
.text-right ::v-deep .v-text-field {
  flex: 1;
  min-width: 0;
}
</style>
